import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

// import BigBookingWidgetHeader from './BigBookingWidgetHeader';
import { BookingCalendar } from 'components/bookingCalendar';
import { ContactUsModal } from 'components/contactUsModal';
import * as constants from './../../constants';
import { Click2CallModal } from 'components/click2CallModal';
import { ShareHotelModal } from 'components/shareHotelModal';
import { Drawer } from '../common/drawer';
// import { Multiproperty } from 'features/multiproperty';
// import { RoomDetails } from '../roomDetails';
// import { PropertyDetails } from 'features/MiniBookingWidget/propertyDetails';
// import { SidebarMenu } from '../sidebarMenu';
import { TrackPricesModal } from 'components/trackPricesModal';
import { useGetBookingData, useScrollToTop, useWindowSize } from 'hooks';

import { closeDrawer } from '../../features/drawersSlice';
import { Picker } from 'components/picker';
import { getLanguageCode } from 'lib';
import { setCalendarOpen, setCurrency, setLanguage } from 'features/userSlice';
import {
    MobilePropertyCard,
    MobilePropertyCardSkeleton,
} from 'components/mobilePropertyCard';
import { MultipropertyFilters } from 'components/multipropertyFilters';
import {
    setMobileSearchOptions,
    setOpenFilters,
    setSelectedPropertyId,
    setMobileDetailsOpen,
} from 'features/multiproperty/MultipropertySlice';
import { MobilePropertyDetails } from 'components/mobilePropertyDetails';
import { BookingHeader } from 'components/bookingHeader';
import { MobileHeaderOptions } from 'components/mobileHeaderOptions';
import { Dropdown } from 'components/common/dropdown';
import { MobileBookingDropdown } from 'components/mobileBookingDropdown';
import { BookingWidgetMap } from 'components/bookingWidgetMap';
import { SinglePropertySidebar } from 'components/singlePropertySidebar';
import { BookingWidgetForm } from 'components/bookingWidgetForm';
import {
    setSelectedFormRoom,
    setSelectedRateID,
    setSelectedRoomForm,
} from 'features/roomBookingFormSlice';
import { RoomDetails } from 'components/roomDetails';
import { setSelectedRoom } from 'features/roomsSlice';
import { Cart } from 'features/cart';
import { CartForm } from 'components/cartForm';
import { setCartOpenState } from 'features/cart/cartSlice';
import { CartItemsMobile } from 'components/cartItemsMobile';
// import './BigBookingWidgetDrawer.css';
// import './Styles.css'; // TODO: THIS IS JUST TEMPORARY (I HOPE SO)

const MobileMultipropertyDrawer = ({ anchor, propertyType, widgetVariant }) => {
    const { getBookingData } = useGetBookingData();
    const dispatch = useDispatch();

    const filteredProperties = useSelector(
        (state) => state.multiproperty.filteredProperties
    );
    const hasCart = useSelector(
        (state) => state.miniBookingWidget?.data?.hasCart
    );
    const multipropertyPropeties =
        useSelector((state) => state.multiproperty.multipropertyProperties) ||
        [];

    const data = useSelector((state) => state.miniBookingWidget?.data);
    const selectedRoomFormIndex = useSelector(
        (state) => state.roomForm.selectedRoomFormIndex
    );
    const selectedRoomIndex = useSelector(
        (state) => state.rooms.selectedRoomIndex
    );
    const sortByText = data?.bigPlugin?.sortByText;

    const Lang = useSelector((state) => state.miniBookingWidget?.data?.Lang);

    const sortByClick2Call = data?.click2CallDropDowns;

    const mapboxAccessToken = useSelector(
        (state) => state.miniBookingWidget?.data?.mapboxAccessToken
    );

    const countries =
        useSelector(
            (state) => state.miniBookingWidget?.data?.pluginCountries
        ) || [];
    const currencies =
        useSelector((state) => state.miniBookingWidget?.data?.pluginCurrency) ||
        [];

    const countryCode = getLanguageCode();

    const selectedCurrency = currencies.find((currency) => {
        return currency.currencySelected === 'selected';
    });
    const selectedCountry = countries.find((country) => {
        return country.countryCode === countryCode;
    });

    const isOpen = useSelector(
        (state) => state.drawers.isMobileMultipropertyDrawerOpen
    );
    const isFetchingPrices = useSelector(
        (state) => state?.miniBookingWidget?.isFetching
    );
    const isFetchingProperties =
        useSelector((state) => state.multiproperty?.isFetching) ||
        isFetchingPrices;

    const ref = useScrollToTop([isFetchingProperties]);

    const isCalendarOpen = useSelector((state) => state.user?.isCalendarOpen);

    const setIsCalendarOpen = useCallback((isOpen) => {
        dispatch(setCalendarOpen({ isCalendarOpen: isOpen }));
    }, []);

    const isMapOpen = useSelector((state) => state.drawers.isMapDrawerOpen);
    const markers = useSelector((state) => state.multiproperty.markers) || [];
    const [currentMonthIndex, setCurrentMonthIndex] = useState(0);

    const {
        isTrackPricesModalOpen,
        isCancellationAndPaymentPolicyModalOpen,
        isContactUsModalOpen,
        isClick2CallModalOpen,
        isShareHotelModalOpen,
        isTermsAndConditionsModalOpen,
        isAmenitiesModalOpen,
    } = useSelector((state) => state.modal);

    const isMobileFiltersOpen = useSelector(
        (state) => state.multiproperty?.isMobileFiltersOpen
    );

    const isMobileDetailsOpen = useSelector(
        (state) => state.multiproperty?.isMobileDetailsOpen
    );

    const closeMap = useCallback(() => {
        dispatch(closeDrawer({ drawerId: 'MapDrawer' }));
    }, []);

    const isMobileSearchOptionsOpen = useSelector(
        (state) => state.multiproperty?.isMobileSearchOptionsOpen
    );
    const isCartOpen = useSelector((state) => state.cart?.open);
    const handleCurrencyChange = (currencyCode) => {
        dispatch(setCurrency({ currency: currencyCode }));
        getBookingData({ currency: currencyCode });
    };

    const handleLanguageChange = async (countryCode) => {
        await dispatch(setLanguage({ language: countryCode }));
        getBookingData({ language: countryCode });
    };

    const closeSelectedRoomForm = () => {
        dispatch(setSelectedRoomForm({ selectedRoomFormIndex: null }));
        dispatch(setSelectedRateID({ selectedRateID: null }));
        dispatch(setSelectedFormRoom({ room: {} }));
    };

    const closeProperyDetails = useCallback(() => {
        dispatch(setSelectedPropertyId({ selectedPropertyId: null }));
        getBookingData();
    }, [setSelectedPropertyId, getBookingData]);

    const openPropertyDetails = useCallback(
        (propertyId, parentPropertyId) => {
            dispatch(setSelectedPropertyId({ selectedPropertyId: propertyId }));
            getBookingData({
                propertyId,
                parentPropertyId,
            });
        },
        [setSelectedPropertyId, getBookingData]
    );

    const selectedPropertyId = useSelector(
        (state) => state.multiproperty?.selectedPropertyId
    );

    const isCartMobileOpen = useSelector(
        (state) => state.cart?.isCartMobileOpen
    );

    const selectedProperty = multipropertyPropeties.find((multiproperty) => {
        return multiproperty.propertyID === selectedPropertyId;
    });

    const propertiesDropdown = multipropertyPropeties?.map((property) => {
        let option = {};

        if (selectedPropertyId === property.propertyID) {
            option = {
                dropdownText: property.propertyName,
                dropdownValue: property.propertyID,
                dropdownSelected: true,
            };
        } else {
            option = {
                dropdownText: property.propertyName,
                dropdownValue: property.propertyID,
                dropdownSelected: false,
            };
        }
        return option;
    });

    const windowSize = useWindowSize();

    const handleClickOutside = useCallback(() => {
        // If track prices modal is open do not close drawer
        if (
            isTrackPricesModalOpen ||
            isCancellationAndPaymentPolicyModalOpen ||
            isContactUsModalOpen ||
            isClick2CallModalOpen ||
            isShareHotelModalOpen ||
            isAmenitiesModalOpen ||
            isTermsAndConditionsModalOpen
        ) {
            return;
        }

        if (isMobileFiltersOpen) {
            dispatch(
                setOpenFilters({
                    isMobileFiltersOpen: !isMobileFiltersOpen,
                })
            );
        } else if (isMobileDetailsOpen) {
            dispatch(
                setMobileDetailsOpen({
                    isMobileDetailsOpen: !isMobileDetailsOpen,
                })
            );
        } else if (isMobileSearchOptionsOpen) {
            dispatch(
                setMobileSearchOptions({
                    isMobileSearchOptionsOpen: !isMobileSearchOptionsOpen,
                })
            );
        } else if (selectedPropertyId) {
            closeProperyDetails();
        } else if (selectedRoomFormIndex !== null) {
            closeSelectedRoomForm();
        } else if (selectedRoomIndex !== null) {
            dispatch(
                setSelectedRoom({
                    selectedRoomIndex: null,
                })
            );
        } else if (isCartOpen) {
            dispatch(setCartOpenState(false));
        } else {
            dispatch(closeDrawer({ drawerId: 'MobileMultipropertyDrawer' }));
            if (document.body.classList.contains('ab-no-overflow')) {
                document.body.classList.remove('ab-no-overflow');
            }
        }
    }, [
        dispatch,
        isTrackPricesModalOpen,
        isCancellationAndPaymentPolicyModalOpen,
        isContactUsModalOpen,
        isClick2CallModalOpen,
        isShareHotelModalOpen,
        isMobileFiltersOpen,
        isMobileSearchOptionsOpen,
        isAmenitiesModalOpen,
        selectedPropertyId,
        isMobileDetailsOpen,
        isTermsAndConditionsModalOpen,
        selectedRoomFormIndex,
        selectedRoomIndex,
    ]);

    useEffect(() => {
        // Set initial values
        dispatch(setCurrency({ currency: selectedCurrency?.currencyCode }));
        dispatch(setLanguage({ language: selectedCountry?.countryCode }));
    }, []);

    return (
        <div>
            <Drawer
                anchor={anchor}
                open={isOpen || widgetVariant === 'openSmallDrawer'}
                className="ab-mobile-carousel"
                right={0}
                width="100%"
            >
                <>
                    <Drawer
                        anchor={anchor}
                        open={
                            propertyType === constants.SINGLE_PROPRETY ||
                            !!selectedPropertyId
                        }
                        height="calc(100vh - 70px)"
                        width="100%"
                        top={70}
                        left={anchor === 'left' ? '69px' : ''}
                    >
                        <MobilePropertyDetails
                            anchor={anchor}
                            closeProperyDetails={closeProperyDetails}
                            property={selectedProperty}
                            showHeader={
                                propertyType === constants.MULTIPROPERTY
                            }
                            openPropertyDetails={openPropertyDetails}
                        />
                    </Drawer>

                    <Drawer
                        anchor="bottom"
                        backdrop
                        elevation={constants.MAX_ZINDEX_VALUE}
                        open={isCalendarOpen}
                        width="100%"
                        height="100%"
                    >
                        <>
                            <BookingHeader
                                iconColor="#1a2024"
                                onClick={() => setIsCalendarOpen(false)}
                            />
                            <BookingCalendar
                                mobile
                                currentMonthIndex={currentMonthIndex}
                                setCurrentMonthIndex={setCurrentMonthIndex}
                            />
                        </>
                    </Drawer>

                    <Drawer
                        anchor="bottom"
                        open={isMobileSearchOptionsOpen}
                        height="calc(100vh - 93px)"
                        width="100%"
                        top={93}
                        left={anchor === 'left' ? '69px' : ''}
                        className="ab-search-options-drawer"
                    >
                        <MobileBookingDropdown Lang={Lang} />
                    </Drawer>

                    {/* Room Details */}
                    <Drawer
                        anchor={anchor}
                        open={selectedRoomIndex !== null}
                        height="calc(100vh - 93px)"
                        top={120}
                        left={anchor === 'left' ? '69px' : ''}
                        width="100%"
                    >
                        <RoomDetails />
                    </Drawer>
                    <Drawer
                        anchor={anchor}
                        open={isMobileFiltersOpen}
                        height="calc(100vh - 60px)"
                        width="100%"
                        top={60}
                        left={anchor === 'left' ? '69px' : ''}
                    >
                        <MultipropertyFilters />
                    </Drawer>
                    <Drawer
                        anchor={anchor}
                        open={selectedRoomFormIndex !== null}
                        height="calc(100vh - 60px)"
                        width="100%"
                        top={60}
                        left={anchor === 'left' ? '69px' : ''}
                    >
                        <BookingWidgetForm extraClass="ab-booking-form-mobile" />
                    </Drawer>
                    <Drawer
                        anchor={anchor}
                        open={isCartOpen !== false}
                        height="calc(100vh - 60px)"
                        width="100%"
                        isCartMobileOpen
                        top={60}
                        left={anchor === 'left' ? '69px' : ''}
                        className="ab-cart"
                        // elevation={'calc(var(--max-z-index) - 1)'}
                    >
                        <CartForm isMobile={true} />
                    </Drawer>
                    <Drawer
                        anchor="bottom"
                        backdrop
                        elevation={constants.MAX_ZINDEX_VALUE}
                        open={isCartMobileOpen}
                        width="100%"
                        height="100%"
                    >
                        <>
                            <CartItemsMobile hasCartExtras={true} />
                        </>
                    </Drawer>
                    {/* single property sidebar */}
                    <Drawer
                        anchor={anchor}
                        open={isMobileDetailsOpen}
                        height="calc(100vh - 60px)"
                        width="100%"
                        top={60}
                        left={anchor === 'left' ? '69px' : ''}
                    >
                        <SinglePropertySidebar mainClass="ab-mobile-sidebar" />
                    </Drawer>

                    {/* Map */}
                    {!!mapboxAccessToken && (
                        <Drawer
                            anchor={anchor}
                            open={isMapOpen}
                            height="calc(100vh - 93px)"
                            width={windowSize.width}
                            top={55}
                            left={anchor === 'left' ? '69px' : ''}
                        >
                            <BookingWidgetMap
                                height="calc(100vh - 140px)"
                                width={windowSize.width}
                                closeMap={closeMap}
                                markers={markers}
                                mapboxAccessToken={mapboxAccessToken}
                                openPropertyDetails={openPropertyDetails}
                            />
                        </Drawer>
                    )}

                    <div className="ab-drawer-mobile">
                        <div className="ab-main">
                            <div className="ab-header">
                                <section className="ab-search-filters">
                                    <div className="ab-search-filters-wrapper">
                                        <div className="ab-search-filters-inner">
                                            <div className="ab-search-form-container">
                                                <div>
                                                    <div>
                                                        <div className="ab-search-form-container-inner">
                                                            <div
                                                                className="ab-header-back"
                                                                onClick={
                                                                    handleClickOutside
                                                                }
                                                            >
                                                                <svg
                                                                    stroke="currentColor"
                                                                    fill="currentColor"
                                                                    strokeWidth="0"
                                                                    viewBox="0 0 24 24"
                                                                    height="30"
                                                                    width="30"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <path
                                                                        fill="none"
                                                                        d="M0 0h24v24H0V0z"
                                                                    ></path>
                                                                    <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"></path>
                                                                </svg>
                                                            </div>

                                                            {selectedPropertyId ? (
                                                                <>
                                                                    <div className="ab-flex-class">
                                                                        <Dropdown
                                                                            label={
                                                                                sortByText
                                                                            }
                                                                            onChange={(
                                                                                option
                                                                            ) => {
                                                                                const propertyId =
                                                                                    option.dropdownValue;
                                                                                const parentPropertyId =
                                                                                    selectedProperty?.parentPropertyID;
                                                                                if (
                                                                                    selectedPropertyId !==
                                                                                    option.dropdownValue
                                                                                ) {
                                                                                    openPropertyDetails(
                                                                                        propertyId,
                                                                                        parentPropertyId
                                                                                    );
                                                                                }
                                                                            }}
                                                                            options={
                                                                                propertiesDropdown ||
                                                                                []
                                                                            }
                                                                            extraClass="ab-properties-dropdown"
                                                                        />
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <div className="ab-header-title">
                                                                    {
                                                                        data?.multiPropertyParentName
                                                                    }
                                                                </div>
                                                            )}

                                                            <div className="ab-lang-and-curr">
                                                                <div className="ab-lang-and-curr">
                                                                    <Picker
                                                                        type="country"
                                                                        data={
                                                                            countries
                                                                        }
                                                                        value={
                                                                            selectedCountry
                                                                        }
                                                                        onChange={
                                                                            handleLanguageChange
                                                                        }
                                                                        title={
                                                                            Lang?.selectYourLanguage
                                                                        }
                                                                    />
                                                                    <Picker
                                                                        type="currency"
                                                                        data={
                                                                            currencies
                                                                        }
                                                                        value={
                                                                            selectedCurrency
                                                                        }
                                                                        onChange={
                                                                            handleCurrencyChange
                                                                        }
                                                                        title={
                                                                            Lang?.selectYourCurrency
                                                                        }
                                                                    />
                                                                    {hasCart && (
                                                                        <Cart
                                                                            isMobile={
                                                                                true
                                                                            }
                                                                        />
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>

                            <div className="ab-body">
                                {isMobileSearchOptionsOpen && (
                                    <div
                                        style={{
                                            width: '100%',
                                            position: 'absolute',
                                            height: '100vh',
                                            background: '#000000a6',
                                            zIndex: '2147483646',
                                        }}
                                    ></div>
                                )}
                                <div className="ab-body-main">
                                    <MobileHeaderOptions
                                        propertyType={propertyType}
                                    />

                                    <div className="ab-multi-results">
                                        {Lang?.multipropertyAppearText}
                                    </div>

                                    <div
                                        className="ab-rooms-container"
                                        ref={ref}
                                    >
                                        {isFetchingProperties ? (
                                            <>
                                                <MobilePropertyCardSkeleton />
                                                <MobilePropertyCardSkeleton />
                                                <MobilePropertyCardSkeleton />
                                            </>
                                        ) : (
                                            (filteredProperties !== null
                                                ? filteredProperties
                                                : multipropertyPropeties
                                            ).map((property, index) => {
                                                return (
                                                    <MobilePropertyCard
                                                        key={index}
                                                        Lang={Lang}
                                                        property={property}
                                                        index={index}
                                                        openPropertyDetails={
                                                            openPropertyDetails
                                                        }
                                                    />
                                                );
                                            })
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            </Drawer>
            {sortByClick2Call?.length > 0 && <Click2CallModal />}

            <ContactUsModal />
            <TrackPricesModal width={'300px'} />
            <ShareHotelModal />
        </div>
    );
};

MobileMultipropertyDrawer.propTypes = {
    anchor: PropTypes.oneOf(['left', 'right', 'middle']),
    propertyType: PropTypes.string,
    widgetVariant: PropTypes.oneOf([
        constants.REGULAR,
        constants.MULTIPROPERTY,
        constants.SMALL,
        constants.OPEN_SMALL_PLUGIN,
        constants.OPEN_BIG_PLUGIN,
        constants.WIDGET_CLICK_2_CALL,
    ]),
};

export default MobileMultipropertyDrawer;
